import { SubtitleWrapper } from './subtitle-display.styles';

const SubtitleDisplay = ({ section }) => {
  const {
    text,
    align,
    fontSize,
    fontSizeMobile,
    background,
    color,
    padding,
    paddingMobile,
    margin,
    marginMobile,
  } = section.content;

  return (
    <SubtitleWrapper
      align={align}
      fontSize={fontSize}
      fontSizeMobile={fontSizeMobile}
      background={background}
      color={color}
      padding={padding}
      paddingMobile={paddingMobile}
      margin={margin}
      marginMobile={marginMobile}
    >
      {text}
    </SubtitleWrapper>
  );
};

export default SubtitleDisplay;